import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const MetricsBar = () => {
  const metrics = [
    {
      id: 'velocity',
      value: '3x',
      label: 'Faster Delivery Velocity',
      description: 'Average improvement in sprint completion rates',
      icon: 'Zap',
      color: 'text-accent'
    },
    {
      id: 'debt',
      value: '90%',
      label: 'Reduction in Technical Debt',
      description: 'Measured decrease in legacy system complexity',
      icon: 'TrendingDown',
      color: 'text-success'
    },
    {
      id: 'transformations',
      value: '50+',
      label: 'Enterprise Transformations',
      description: 'Successful engineering culture changes delivered',
      icon: 'Building',
      color: 'text-warning'
    },
    {
      id: 'satisfaction',
      value: '95%',
      label: 'Team Satisfaction Score',
      description: 'Developer happiness and engagement metrics',
      icon: 'Heart',
      color: 'text-error'
    }
  ];

  return (
    <section className="py-16 bg-primary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Proven Results Across Enterprise Engineering Teams
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Quantified improvements from our embedded engineering transformation methodology
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <motion.div
              key={metric.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 hover:bg-white/10">
                <div className="flex justify-center mb-4">
                  <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon name={metric.icon} size={24} className={`${metric.color}`} />
                  </div>
                </div>

                <div className="mb-2">
                  <div className="text-4xl font-bold text-white mb-1">{metric.value}</div>
                  <div className="text-lg font-semibold text-gray-300">{metric.label}</div>
                </div>

                <p className="text-sm text-gray-400 leading-relaxed">
                  {metric.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <div className="inline-flex items-center px-6 py-3 bg-white/10 rounded-full text-white text-sm">
            <Icon name="Shield" size={16} className="mr-2 text-accent" />
            All metrics verified through independent third-party assessments
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MetricsBar;
